export const ANALYTICS = "Analytics";
export const NEW_PATIENT = "New Patient";
export const MISSED_APPOINTMENTS = "Missed Appointment";
export const PAYMENT_POSTING = "Payment Posting";
export const RECONCILIATIONS = "Reconciliations";
export const FINANTIAL_UPDATES = "Finantial Updates";
export const X_RAYS = "X-rays";
export const POWER_BI = "PowerBI";
